import React from "react";
import { assetImg } from "@/modules/moduleImporter";
import img_back_card from "@/assets/img/img_back_card.png";

import "./index.scss";

interface IProps {
	pathkey?: string;
	lie?: boolean;
	active?: boolean;

	cardImage: string;
}

export default class FlippingCard extends React.Component<IProps> {
	imgBackCard = <img src={img_back_card} className="backside" alt="back side" key="bs" />;

	render() {
		const pathKey = this.props.pathkey || "baccarat";

		return (
			<div className={
				"flipping-card" +
				(this.props.lie ? " lie" : "") +
				(this.props.active ? " active" : "")}>

				{
					this.props.active
						? [
							// <img src={this.cardImages[this.props.cardImage]}
							//  alt={this.props.cardImage}
							//  className="frontside"
							//  key="fs" />,
							assetImg(pathKey, this.props.cardImage, `fs`, "frontside"),
							this.imgBackCard
						] : this.imgBackCard
				}
			</div>
		);
	}
}